import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import withRoles from './hoc/withRoles';
import classNames from 'classnames';
import Spinner from './components/spinner';
import routes from './routes';
import withAuthProvider from './hoc/withAuthProvider';
import withFetch from './hoc/withFetch';
import { reactPlugin, appInsights } from './hoc/withAppInsights';
import Header from './components/header';
import ScrollToTop from "./components/scrolltop";
import './App.scss';

const App = (props) => {

  appInsights.trackPageView({
    name: document.title, uri: window.location.href,
    properties: {
      UserName: props.user && props.user.idToken && props.user.idToken['signInNames.emailAddress']
    }
  });

  return (
    <Router>
      <ScrollToTop />
      <div className={classNames({
        'app': true,
        'app--not-auth': !props.isAuthenticated
      })}>
        {(!props.isAuthenticated || !props.roles) &&
          <div className="authenticate">
            <Spinner isLoading={props.isLoading || props.isLoadingRoles} fast={true} />
          </div>
        }

      {props.isAuthenticated && props.roles &&
        <Switch>
          {routes.map((route, i) => {
            return (
              <Route 
                key={i} 
                path={route.path} 
                exact={route.exact} 
                render={(routeProps) => {
                  return (
                    <div className={classNames({
                      'app__content': true,
                      'app__content--no-header': route.hideHeader,
                      'app__content--beta-bar': route.type === 'foodservice' || route.type === 'livs'
                    })}>
                        {!route.hideHeader &&
                          <Header route={route} {...props} />
                        }
                        <div className="app-content">
                            <route.component  {...props} {...routeProps} type={route.type} />
                        </div>
                      </div>
                  );
                }}  />
              );
            }
          )}
        </Switch>
      }
    
      </div>
    </Router>
  );
}

export default withAITracking(reactPlugin, withAuthProvider(withFetch(withRoles(App))));
